(() => {
  const root = document.querySelector('[data-js-faq-root]');
  if (!root) return;

  const items = Array.from(root.querySelectorAll('[data-faq-item]'));
  const filterButtons = Array.from(root.querySelectorAll('[data-faq-filter]'));
  const select = root.querySelector('[data-faq-select]');

  function readThemeSignal() {
    const html = document.documentElement;
    const body = document.body;

    // Match the accepted How It Works architecture first:
    // html[data-js-theme="dark"] / html[data-js-theme="light"].
    const htmlJsTheme = (html.getAttribute('data-js-theme') || '').toLowerCase();
    if (htmlJsTheme === 'dark' || htmlJsTheme === 'light') return htmlJsTheme;

    const htmlTheme = (html.getAttribute('data-theme') || '').toLowerCase();
    if (htmlTheme === 'dark' || htmlTheme === 'light') return htmlTheme;

    const bodyJsTheme = (body.getAttribute('data-js-theme') || '').toLowerCase();
    if (bodyJsTheme === 'dark' || bodyJsTheme === 'light') return bodyJsTheme;

    const bodyTheme = (body.getAttribute('data-theme') || '').toLowerCase();
    if (bodyTheme === 'dark' || bodyTheme === 'light') return bodyTheme;

    const classText = `${html.className || ''} ${body.className || ''}`.toLowerCase();
    if (classText.includes('theme-dark') || classText.includes('dark-mode') || /\bdark\b/.test(classText)) return 'dark';
    if (classText.includes('theme-light') || classText.includes('light-mode') || /\blight\b/.test(classText)) return 'light';

    // Important: do NOT read root[data-theme] as a source of truth.
    // Root is the target, not the sensor. Safe fallback is dark.
    return 'dark';
  }

  function setThemeFromPage() {
    const theme = readThemeSignal();
    root.setAttribute('data-theme', theme);
  }

  function setAnswerHeight(item, open) {
    const answer = item.querySelector('.js-faq-answer');
    if (!answer) return;

    if (open) {
      answer.style.height = '0px';
      answer.offsetHeight;
      answer.style.height = `${answer.scrollHeight}px`;
      const onEnd = (event) => {
        if (event.target !== answer) return;
        if (item.classList.contains('is-open')) answer.style.height = 'auto';
        answer.removeEventListener('transitionend', onEnd);
      };
      answer.addEventListener('transitionend', onEnd);
    } else {
      if (answer.style.height === 'auto') answer.style.height = `${answer.scrollHeight}px`;
      answer.offsetHeight;
      answer.style.height = '0px';
    }
  }

  function closeItem(item) {
    if (!item.classList.contains('is-open')) return;
    item.classList.remove('is-open');
    const button = item.querySelector('.js-faq-question');
    if (button) button.setAttribute('aria-expanded', 'false');
    setAnswerHeight(item, false);
  }

  function openOnly(item) {
    items.forEach((other) => {
      if (other !== item) closeItem(other);
    });
    item.classList.add('is-open');
    const button = item.querySelector('.js-faq-question');
    if (button) button.setAttribute('aria-expanded', 'true');
    setAnswerHeight(item, true);
  }

  function toggleItem(item) {
    if (item.classList.contains('is-open')) closeItem(item);
    else openOnly(item);
  }

  function applyFilter(category) {
    filterButtons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.faqFilter === category);
    });

    if (select) select.value = category;

    let firstVisible = null;
    items.forEach((item) => {
      const categories = (item.dataset.category || '').split(/\s+/);
      const visible = category === 'all' || categories.includes(category);
      item.classList.toggle('is-hidden', !visible);
      if (visible && !firstVisible) firstVisible = item;
      if (!visible) closeItem(item);
    });

    if (firstVisible) openOnly(firstVisible);
  }

  items.forEach((item) => {
    const button = item.querySelector('.js-faq-question');
    if (!button) return;
    button.addEventListener('click', () => toggleItem(item));
  });

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => applyFilter(button.dataset.faqFilter));
  });

  if (select) {
    select.addEventListener('change', (event) => applyFilter(event.target.value));
  }

  const revealTargets = Array.from(root.querySelectorAll('.js-faq-reveal'));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealTargets.forEach((target) => observer.observe(target));
  } else {
    revealTargets.forEach((target) => target.classList.add('is-visible'));
  }

  setThemeFromPage();

  requestAnimationFrame(() => {
    items.forEach((item) => {
      const answer = item.querySelector('.js-faq-answer');
      if (!answer) return;
      if (item.classList.contains('is-open')) answer.style.height = 'auto';
      else answer.style.height = '0px';
    });
  });

  const themeObserver = new MutationObserver(setThemeFromPage);
  themeObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'data-theme', 'data-js-theme'] });
  themeObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'data-theme', 'data-js-theme'] });

  window.addEventListener('resize', () => {
    items.forEach((item) => {
      const answer = item.querySelector('.js-faq-answer');
      if (!answer) return;
      if (item.classList.contains('is-open')) answer.style.height = 'auto';
      else answer.style.height = '0px';
    });
  }, { passive: true });
})();
